export const forBusiness_jewelry_effective = [
	{
		icon: '✅',
		title: 'effectiveData_title1',
		subtitle: 'effectiveData_subtitle1',
	},
	{
		icon: '✅',
		title: 'effectiveData_title2',
		subtitle: 'effectiveData_subtitle2',
	},
	{
		icon: '✅',
		title: 'effectiveData_title3',
		subtitle: 'effectiveData_subtitle3',
	},
	{
		icon: '✅',
		title: 'effectiveData_title4',
		subtitle: 'effectiveData_subtitle4',
	},
];

export const effectiveAboveList = [
	{
		text: 'effectiveData_textAbove_text1',
	},
];
